"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getUserAssessmentsMock = {
    assessments: [
        {
            id: 7,
            name: 'Assessment #7',
            state: 'completed',
            score: 50,
            category_ratings: { Injection: 33, 'XML External Entities (XXE)': 100 },
            categories: ['Injection', 'XML External Entities (XXE)'],
        },
        {
            id: 8,
            name: 'Assessment #8',
            state: 'completed',
            score: 25,
            category_ratings: { Injection: 33, 'XML External Entities (XXE)': 0 },
            categories: ['Injection', 'XML External Entities (XXE)'],
        },
        {
            id: 9,
            name: 'Assessment #9',
            state: 'not_started',
            score: null,
            category_ratings: null,
            categories: ['Injection', 'XML External Entities (XXE)'],
        },
    ],
    statistics: {
        highest_score: 50,
        total_assessments: 3,
        completed_assessments: 2,
        success_rate: 37.5,
    },
};
exports.default = getUserAssessmentsMock;
